/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
(function (global) {
  global.ng ??= {};
  global.ng.common ??= {};
  global.ng.common.locales ??= {};
  const u = undefined;
  function plural(val) {
    const n = val;
    if (n === 1) return 1;
    return 5;
  }
  global.ng.common.locales['nn'] = ["nn", [["a", "p"], ["f.m.", "e.m."], ["a.m.", "p.m."]], [["f.m.", "e.m."], ["a.m.", "p.m."], u], [["S", "M", "T", "O", "T", "F", "L"], ["sø.", "må.", "ty.", "on.", "to.", "fr.", "la."], ["søndag", "måndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"], ["sø.", "må.", "ty.", "on.", "to.", "fr.", "la."]], [["S", "M", "T", "O", "T", "F", "L"], ["søn", "mån", "tys", "ons", "tor", "fre", "lau"], ["søndag", "måndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"], ["sø.", "må.", "ty.", "on.", "to.", "fr.", "la."]], [["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"], ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."], ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]], [["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"], ["jan", "feb", "mar", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "des"], ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]], [["f.Kr.", "e.Kr."], u, ["før Kristus", "etter Kristus"]], 1, [6, 0], ["dd.MM.y", "d. MMM y", "d. MMMM y", "EEEE d. MMMM y"], ["HH:mm", "HH:mm:ss", "HH:mm:ss z", "'kl'. HH:mm:ss zzzz"], ["{1}, {0}", u, "{1} 'kl'. {0}", "{1} {0}"], [",", " ", ";", "%", "+", "−", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0 %", "#,##0.00 ¤", "#E0"], "NOK", "kr", "norske kroner", {
    "AUD": [u, "$"],
    "BRL": [u, "R$"],
    "BYN": [u, "р."],
    "CAD": [u, "$"],
    "CNY": [u, "¥"],
    "GBP": [u, "£"],
    "HKD": [u, "$"],
    "ILS": [u, "₪"],
    "INR": [u, "₹"],
    "JPY": [u, "¥"],
    "KRW": [u, "₩"],
    "MXN": [u, "$"],
    "NOK": ["kr"],
    "NZD": [u, "$"],
    "PHP": [u, "₱"],
    "TWD": [u, "$"],
    "USD": [u, "$"],
    "VND": [u, "₫"],
    "XAF": [],
    "XCD": [u, "$"],
    "XPF": [],
    "XXX": []
  }, "ltr", plural, [[["mn.", "mg.", "fm.", "em.", "kv.", "nt."], ["midn.", "morg.", "form.", "etterm.", "kveld", "natt"], ["midnatt", "på morgonen", "på formiddagen", "på ettermiddagen", "på kvelden", "på natta"]], [["mn.", "mg.", "fm.", "em.", "kv.", "nt."], ["midn.", "morg.", "form.", "etterm.", "kveld", "natt"], ["midnatt", "morgon", "formiddag", "ettermiddag", "kveld", "natt"]], ["00:00", ["06:00", "10:00"], ["10:00", "12:00"], ["12:00", "18:00"], ["18:00", "24:00"], ["00:00", "06:00"]]]];
})(globalThis);